var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrderArticle',{staticClass:"-highlighted",attrs:{"article":_vm.article,"disabled":_vm.disabled,"is-complete":_vm.isComplete}}),_vm._l((_vm.orderSuggestion),function(data){return _c('EntityArticle',{key:data.id,attrs:{"data":data,"disabled":_vm.disabled,"is-complete":_vm.isComplete}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }